/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faFolderOpen} from '@fortawesome/pro-duotone-svg-icons';

const CategoriesIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faFolderOpen} {...props} />
);

export default CategoriesIcon;
